import React from "react";
import { ContextMenu } from "@packsize/components";
import { FormattedMessage } from "react-intl";
import { MenuItem, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface PackagingSolutionActionMenuProps {
	readonly internalUniqueId: string;
	readonly alias: string;
	readonly removeItem: (id: string, alias: string) => void;
	readonly userCanRemove: boolean;
}

const PackagingSolutionActionMenu: React.FC<PackagingSolutionActionMenuProps> = ({
	internalUniqueId,
	alias,
	removeItem,
	userCanRemove,
}) => {
	const navigate = useNavigate();

	return (
		<ContextMenu
			popoverProps={{
				anchorOrigin: {
					vertical: "bottom",
					horizontal: "center",
				},
				transformOrigin: {
					vertical: "top",
					horizontal: "right",
				},
			}}
		>
			<MenuItem onClick={() => navigate(`/dashboard/packaging-solution-audit-trail/${internalUniqueId}`)}>
				<Typography variant="body2">
					<FormattedMessage id="See Details" defaultMessage="See Details" />
				</Typography>
			</MenuItem>
			{userCanRemove === true && (
				<MenuItem onClick={() => removeItem(internalUniqueId, alias)}>
					<Typography variant="body2">
						<FormattedMessage id="Remove" defaultMessage="Remove" />
					</Typography>
				</MenuItem>
			)}
		</ContextMenu>
	);
};

export default PackagingSolutionActionMenu;
